package uk.co.nickthecoder.shaders

import org.khronos.webgl.WebGLRenderingContext.Companion.TEXTURE_2D
import uk.co.nickthecoder.glok.backend.Texture
import uk.co.nickthecoder.glok.backend.webgl.WebGLBackend
import uk.co.nickthecoder.glok.util.Matrix
import uk.co.nickthecoder.kyd.shapes.Mesh

actual class ShellTexProgram : UProgram(VERTEX, FRAGMENT) {

    override val hasAcrossAttribute: Boolean get() = true

    fun begin(viewMatrix: Matrix, modelMatrix: Matrix, texture: Texture) {
        begin(viewMatrix, modelMatrix)
        texture.bind()
    }

    override fun end() {
        super.end()
        WebGLBackend.gl.bindTexture(TEXTURE_2D, null)
    }

    actual companion object {

        private val instance = ShellTexProgram()

        actual fun draw(mesh: Mesh, viewMatrix: Matrix, modelMatrix: Matrix, texture: Texture) {
            with(instance) {
                begin(viewMatrix, modelMatrix, texture)
                draw(mesh)
                end()
            }

        }

    }
}

private const val VERTEX = """
attribute vec2 position;
attribute float u;

uniform mat3 viewMatrix;
uniform mat3 modelMatrix;

varying float fragmentU;

void main() {
    fragmentU = u;

    gl_Position = vec4( viewMatrix * modelMatrix * vec3(position, 1.0), 1.0);
}

"""

private const val FRAGMENT = """
precision highp float;

varying float fragmentU;

uniform sampler2D texImage;
uniform vec4 tint;

void main() {
    gl_FragColor = texture2D(texImage, vec2(fragmentU, 0.5);
}

"""
